import isUndefined from 'lodash/isUndefined';

// make a Layer Tap Key Keycode Definition
function makeLT(layer) {
  return {
    name: `LT ${layer}`,
    code: `LT(${layer},kc)`,
    type: 'layer-container',
    layer: layer,
    title: `点按是设定的键, 按住超过200ms则切换到层${layer}`
  };
}
// make a One-Shot Mod Keycode Definition
const osmLookup = {
  MOD_LSFT: ['LSft', 'Left Shift'],
  MOD_LCTL: ['LCtl', 'Left Control'],
  MOD_LALT: ['LAlt', 'Left Alt'],
  MOD_LGUI: ['LGUI', 'Left GUI'],
  MOD_RSFT: ['RSft', 'Right Shift'],
  MOD_RCTL: ['RCtl', 'Right Control'],
  MOD_RALT: ['RAlt', 'Right Alt'],
  MOD_RGUI: ['RGUI', 'Right GUI'],
  MOD_HYPR: ['Hyper', 'Control, Shift, Alt 和 GUI'],
  MOD_MEH: ['Meh', 'Control, Shift, 和 Alt'],
  'MOD_LCTL|MOD_LSFT': ['CS', 'Control 和 Shift'],
  'MOD_LCTL|MOD_LALT': ['CA', 'Control 和 Alt'],
  'MOD_LCTL|MOD_LGUI': ['CG', 'Control 和 GUI'],
  'MOD_LSFT|MOD_LALT': ['SA', 'Shift 和 Alt'],
  'MOD_LSFT|MOD_LGUI': ['SG', 'Shift 和 GUI'],
  'MOD_LALT|MOD_LGUI': ['AG', 'Alt 和 GUI'],
  'MOD_LCTL|MOD_LSFT|MOD_LGUI': ['CSG', 'Control, Shift, 和 GUI'],
  'MOD_LCTL|MOD_LALT|MOD_LGUI': ['CAG', 'Control, Alt, 和 GUI'],
  'MOD_LSFT|MOD_LALT|MOD_LGUI': ['SAG', 'Shift, Alt, 和 GUI']
};
function makeOSM(mod, width = 1000) {
  const tuple = osmLookup[mod];
  if (isUndefined(tuple)) {
    throw new Error(`${mod} 不是合法的单点模式`);
  }
  const [name, title] = tuple;
  return {
    name: `OSM ${name}`,
    code: `OSM(${mod})`,
    title: `为点按一次而启用 ${title}`,
    width: width
  };
}

export default [
  { label: 'Quantum', width: 'label', group: true },

  { label: '特殊', width: 'label' },

  { name: '', code: 'KC_NO', title: '无' },
  {
    name: '▽',
    code: 'KC_TRNS',
    title: '穿透到下层'
  },
  // { name: 'Reset', code: 'RESET', title: 'Reset the keyboard' },
  // { name: 'Debug', code: 'DEBUG', title: 'Toggle debug mode' },
  // {
  //   name: 'EEPROM Reset',
  //   code: 'EEP_RST',
  //   title: 'Resets EEPROM state',
  //   width: 1500
  // },
  // { width: 1000 },
  // {
  //   name: 'Any',
  //   code: 'text',
  //   type: 'text',
  //   title: 'Manually enter any QMK keycode'
  // },
  {
    label: '层切换',
    icon: 'exclamation-triangle',
    iconClass: 'warning',
    width: 'label',
    title: '注意：请将目标层上的对应键设为穿透键▽，否则可能锁定层'
  },

  {
    name: 'MO',
    code: 'MO(layer)',
    type: 'layer',
    layer: 0,
    title: '瞬时切换到层：按下时打开层，抬起时返回'
  },
  {
    name: 'TG',
    code: 'TG(layer)',
    type: 'layer',
    layer: 0,
    title: '层在打开、关闭状态间切换'
  },
  {
    name: 'TO',
    code: 'TO(layer)',
    type: 'layer',
    layer: 0,
    title: '按下打开层'
  },
  {
    name: 'TT',
    code: 'TT(layer)',
    type: 'layer',
    layer: 0,
    title:
      '通常，它的行为类似于MO：按下时打开层，抬起时返回；如果它被快速连击2次，就持续打开层'
  },
  {
    name: 'DF',
    code: 'DF(layer)',
    type: 'layer',
    layer: 0,
    title: '设置默认层'
  },
  {
    name: 'OSL',
    code: 'OSL(layer)',
    type: 'layer',
    layer: 0,
    title: '切换到层，按一个键后返回默认层'
  },

  { width: 500 },

  makeLT(0),
  makeLT(1),
  makeLT(2),
  makeLT(3),
  makeLT(4),
  makeLT(5),
  makeLT(6),
  /*
  makeLT(7),
  { width: 250 },
  makeLT(8),
  makeLT(9),
  makeLT(10),
  makeLT(11),
  makeLT(12),
  makeLT(13),
  makeLT(14),
  makeLT(15),
  */
  {
    label: '组合模式键 (A = Alt, C = Control, G = Windows/Command, S = Shift)',
    width: 'label'
  },

  { name: 'LSft', code: 'LSFT(kc)', type: 'container' },
  { name: 'LCtl', code: 'LCTL(kc)', type: 'container' },
  { name: 'LAlt', code: 'LALT(kc)', type: 'container' },
  { name: 'LGui', code: 'LGUI(kc)', type: 'container' },
  { name: 'RSft', code: 'RSFT(kc)', type: 'container' },
  { name: 'RCtl', code: 'RCTL(kc)', type: 'container' },
  { name: 'RAlt', code: 'RALT(kc)', type: 'container' },
  { name: 'RGui', code: 'RGUI(kc)', type: 'container' },
  { width: 0 },
  {
    name: 'LSft_T',
    code: 'LSFT_T(kc)',
    type: 'container',
    title: '按住是左Shift，单击是设定的键'
  },
  {
    name: 'LCtl_T',
    code: 'LCTL_T(kc)',
    type: 'container',
    title: '按住是左Control，单击是设定的键'
  },
  {
    name: 'LAlt_T',
    code: 'LALT_T(kc)',
    type: 'container',
    title: '按住是左Alt，单击是设定的键'
  },
  {
    name: 'LGui_T',
    code: 'LGUI_T(kc)',
    type: 'container',
    title: '按住是左GUI，单击是设定的键'
  },
  {
    name: 'RSft_T',
    code: 'RSFT_T(kc)',
    type: 'container',
    title: '按住是右Shift，单击是设定的键'
  },
  {
    name: 'RCtl_T',
    code: 'RCTL_T(kc)',
    type: 'container',
    title: '按住是右Control，单击是设定的键'
  },
  {
    name: 'RAlt_T',
    code: 'RALT_T(kc)',
    type: 'container',
    title: '按住是右Alt，单击是设定的键'
  },
  {
    name: 'RGui_T',
    code: 'RGUI_T(kc)',
    type: 'container',
    title: '按住是右GUI，单击是设定的键'
  },
  {
    name: 'C_S_T',
    code: 'C_S_T(kc)',
    type: 'container',
    title: '按住是左Control + Shift，单击是设定的键'
  },
  {
    name: 'All_T',
    code: 'ALL_T(kc)',
    type: 'container',
    title: '按住是LCTL + LSFT + LALT + LGUI，单击是设定的键'
  },
  {
    name: 'Meh_T',
    code: 'MEH_T(kc)',
    type: 'container',
    title: '按住是LCTL + LSFT + LALT，单击是设定的键'
  },
  {
    name: 'LCAG_T',
    code: 'LCAG_T(kc)',
    type: 'container',
    title: '按住是LCTL + LALT + LGUI，单击是设定的键'
  },
  {
    name: 'RCAG_T',
    code: 'RCAG_T(kc)',
    type: 'container',
    title: '按住是RCTL + RALT + RGUI，单击是设定的键'
  },
  {
    name: 'SGUI_T',
    code: 'SGUI_T(kc)',
    type: 'container',
    title: '按住是LGUI + LSFT，单击是设定的键'
  },
  {
    name: 'LCA_T',
    code: 'LCA_T(kc)',
    type: 'container',
    title: '按住是LCTL + LALT，单击是设定的键'
  },
  { width: 0 },
  {
    name: 'Hyper',
    code: 'HYPR(kc)',
    type: 'container',
    title: 'LCTL + LSFT + LALT + LGUI'
  },
  {
    name: 'Meh',
    code: 'MEH(kc)',
    type: 'container',
    title: 'LCTL + LSFT + LALT'
  },
  {
    name: 'LCAG',
    code: 'LCAG(kc)',
    type: 'container',
    title: 'LCTL + LALT + LGUI'
  },
  {
    name: 'SGUI',
    code: 'SGUI(kc)',
    type: 'container',
    title: 'LGUI + LSFT'
  },
  {
    name: 'LCA',
    code: 'LCA(kc)',
    type: 'container',
    title: 'LCTL + LALT'
  },

  { width: 0 },

  makeOSM('MOD_LSFT'),
  makeOSM('MOD_LCTL'),
  makeOSM('MOD_LALT'),
  makeOSM('MOD_LGUI'),
  { width: 250 },
  makeOSM('MOD_RSFT'),
  makeOSM('MOD_RCTL'),
  makeOSM('MOD_RALT'),
  makeOSM('MOD_RGUI'),
  { width: 250 },
  makeOSM('MOD_LCTL|MOD_LSFT'),
  makeOSM('MOD_LCTL|MOD_LALT'),
  makeOSM('MOD_LCTL|MOD_LGUI'),
  makeOSM('MOD_LSFT|MOD_LALT'),
  makeOSM('MOD_LSFT|MOD_LGUI'),
  makeOSM('MOD_LALT|MOD_LGUI'),
  { width: 250 },
  makeOSM('MOD_LCTL|MOD_LSFT|MOD_LGUI'),
  makeOSM('MOD_LCTL|MOD_LALT|MOD_LGUI'),
  makeOSM('MOD_LSFT|MOD_LALT|MOD_LGUI'),
  { width: 250 },
  makeOSM('MOD_MEH'),
  makeOSM('MOD_HYPR'),
  { width: 250 },

  { label: '特殊动作及宏', width: 'label' },

  {
    name: 'Esc/~',
    code: 'KC_GESC',
    title: '通常是Esc，Shift或GUI 按下时是 ~'
  },
  {
    name: 'LS/(',
    code: 'KC_LSPO',
    title: '按住是左Shift，点按是 ('
  },
  {
    name: 'RS/)',
    code: 'KC_RSPC',
    title: '按住是右 Shift，点按是 )'
  },
  {
    name: 'LC/(',
    code: 'KC_LCPO',
    title: '按住是左Control，点按是 ('
  },
  {
    name: 'RC/)',
    code: 'KC_RCPC',
    title: '按住是右Control，点按是 )'
  },
  /*
  {
    name: 'LA/(',
    code: 'KC_LAPO',
    title: 'Left Alt when held, ( when tapped'
  },
  {
    name: 'RA/)',
    code: 'KC_RAPC',
    title: 'Right Alt when held, ) when tapped'
  },
  */
  {
    name: 'RS / Enter',
    code: 'KC_SFTENT',
    title: '按住是右Shift，点按是 Enter '
  },

  { width: 1000 },

  {
    name: 'M',
    code: 'M(mid)',
    type: 'macro',
    layer: 0,
    title: '执行指定编号的宏'
  },
  
  { width: 1000 },

  {
    name: 'TD',
    code: 'TD(tdid)',
    type: 'tapdance',
    layer: 0,
    title: '执行指定编号的Tap Dance'
  },
  

];
